export const state = {
  // Toggles the RecurringEventOccurrenceWizard appearance
  openRecurringEventOccurrenceWizard: false,
  // Occurrence we would like to edit
  occurrenceToEditId: '',
  occurrenceToEditParent: '',
  occurrenceToEditType: '',
  occurrenceToEditStart: '',
  occurrenceToEditEnd: '',
  occurrenceToEditMachine: '',
};

export const mutations = {
  /**
   * Closes the recurring event occurrence wizard
   * @param state
   */
  closeOccurrenceWizard(state) {
    state.openRecurringEventOccurrenceWizard = false;
    state.occurrenceToEditId = '';
    state.occurrenceToEditParent = '';
    state.occurrenceToEditType = '';
    state.occurrenceToEditStart = '';
    state.occurrenceToEditEnd = '';
    state.occurrenceToEditMachine = '';
  },
  /**
   * Opens the recurring event occurrence wizard for edition
   * @param state
   * @param occurrence
   * @param locale
   * @param machine
   */
  editOccurrence(state, payload) {
    const { occurrence, locale, machine } = payload;
    state.occurrenceToEditId = occurrence.event_id;
    state.occurrenceToEditParent = occurrence.parent;
    let localeOverrideLocale = locale;
    if (!localeOverrideLocale) {
      localeOverrideLocale = 'fr';
    }

    state.occurrenceToEditType = occurrence?.event_number?.names[localeOverrideLocale];
    state.occurrenceToEditStart = occurrence.event_start;
    state.occurrenceToEditEnd = occurrence.event_end;
    state.occurrenceToEditMachine = machine;
    state.openRecurringEventOccurrenceWizard = true;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
